import { ErrorCodes } from "@next-platform/client-common-core";

export const CUSTOM_ERROR_MESSAGES = {
  [ErrorCodes.USER_PERSONA_ERROR_TYPE_SC_001_4207]:
    "Underage Content Detected: This content is not allowed. Further attempts may lead to account suspension or termination.",
  [ErrorCodes.IMAGE_ERROR_SC_001_6801]:
    "Underage Content Detected: This content is not allowed. Further attempts may lead to account suspension or termination.",
  [ErrorCodes.USER_PERSONA_ERROR_TYPE_SC_001_4208]:
    "Explicit Content Detected: NSFW content is not allowed on PixelChat. Please remove or revise to continue.",
  [ErrorCodes.IMAGE_ERROR_SC_001_6802]: "Explicit Content Detected: NSFW content is not allowed on PixelChat. Please remove or revise to continue.",
  [ErrorCodes.CHARACTER_ERROR_SC_001_1215]:
    "Underage Content Detected: This content is not allowed. Further attempts may lead to account suspension or termination.",
  [ErrorCodes.CHARACTER_ERROR_SC_001_1213]:
    "Underage Content Detected: This content is not allowed. Further attempts may lead to account suspension or termination.",
  [ErrorCodes.CHARACTER_ERROR_SC_001_1214]:
    "Underage Content Detected: This content is not allowed. Further attempts may lead to account suspension or termination.",
  [ErrorCodes.CHARACTER_ERROR_SC_001_1212]:
    "Explicit Content Detected: NSFW content is not allowed on PixelChat. Please remove or revise to continue.",
  [ErrorCodes.CHARACTER_ERROR_SC_001_1203]:
    "Explicit Content Detected: NSFW content is not allowed on PixelChat. Please remove or revise to continue.",
};
